import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-222fe174"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pbl_xsj"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "topbg"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottombg"
}, null, -1));
const _hoisted_4 = {
  class: "wrap"
};
const _hoisted_5 = {
  class: "wrapinner",
  id: "wrapinner"
};
const _hoisted_6 = {
  class: "wrapbox"
};
const _hoisted_7 = {
  class: "videoBox"
};
const _hoisted_8 = {
  class: "nameWarp"
};
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  class: "sex"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  key: 0,
  class: "item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "别名：", -1));
const _hoisted_15 = {
  key: 1,
  class: "item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "籍贯：", -1));
const _hoisted_17 = {
  key: 2,
  class: "item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出生年月：", -1));
const _hoisted_19 = {
  key: 3,
  class: "item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d_reason"
}, "何时何地牺牲（病故）：", -1));
const _hoisted_21 = {
  class: "d_reason_detail"
};
const _hoisted_22 = {
  class: "content"
};
const _hoisted_23 = {
  key: 0,
  class: "item"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "别名：", -1));
const _hoisted_25 = {
  key: 1,
  class: "item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "籍贯：", -1));
const _hoisted_27 = {
  key: 2,
  class: "item"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出生年月：", -1));
const _hoisted_29 = {
  key: 3,
  class: "item"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d_reason"
}, "何时何地牺牲（病故）：", -1));
const _hoisted_31 = {
  class: "d_reason_detail"
};
const _hoisted_32 = {
  class: "nameWarp"
};
const _hoisted_33 = {
  class: "name"
};
const _hoisted_34 = {
  class: "sex"
};
const _hoisted_35 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "line",
    style: _normalizeStyle(`top:${$data.lineTop}px; bottom:${$data.lineBottom}px`)
  }, null, 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_7, [!(index % 2) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "videoBoxli",
      style: {
        "padding-left": "30px"
      },
      ref_for: true,
      ref: `videoBoxli_${index}`
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.sex ? `(${item.sex})` : ''), 1), _createElementVNode("div", {
      class: _normalizeClass(`desc ${item.desc_type} ${item.desc_size <= 18 ? 'desc_2' : ''}`),
      style: _normalizeStyle(`font-size: ${item.desc_size}px`)
    }, [item.desc.split('、').length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.desc), 1)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.desc.split('、'), d => {
      return _openBlock(), _createElementBlock("div", null, _toDisplayString(d), 1);
    }), 256))], 6)]), _createElementVNode("div", {
      class: _normalizeClass({
        'icon': true,
        'icon_r': true,
        'icon_f': !index,
        'icon_end': index == $data.list.length - 1
      })
    }, null, 2), _createElementVNode("div", _hoisted_12, [item.other_name ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createTextVNode(_toDisplayString(item.other_name), 1)])) : _createCommentVNode("", true), item.place ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createTextVNode(_toDisplayString(item.place), 1)])) : _createCommentVNode("", true), item.year ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_hoisted_18, _createTextVNode(_toDisplayString(item.year), 1)])) : _createCommentVNode("", true), item.d_reason ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(item.d_reason), 1)])) : _createCommentVNode("", true)])], 512)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "videoBoxli",
      style: {
        "padding-left": "-30px"
      },
      ref_for: true,
      ref: `videoBoxli_${index}`
    }, [_createElementVNode("div", _hoisted_22, [item.other_name ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_hoisted_24, _createTextVNode(_toDisplayString(item.other_name), 1)])) : _createCommentVNode("", true), item.place ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, _createTextVNode(_toDisplayString(item.place), 1)])) : _createCommentVNode("", true), item.year ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createTextVNode(_toDisplayString(item.year), 1)])) : _createCommentVNode("", true), item.d_reason ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString(item.d_reason), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: _normalizeClass({
        'icon': true,
        'icon_l': true,
        'icon_f': !index,
        'icon_end': index == $data.list.length - 1
      })
    }, null, 2), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_34, _toDisplayString(item.sex ? `(${item.sex})` : ''), 1), _createElementVNode("div", {
      class: _normalizeClass(`desc ${item.desc_type} ${item.desc_size <= 18 ? 'desc_2' : ''}`),
      style: _normalizeStyle(`font-size: ${item.desc_size}px`)
    }, [item.desc.split('、').length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(item.desc), 1)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(item.desc.split('、'), d => {
      return _openBlock(), _createElementBlock("div", null, _toDisplayString(d), 1);
    }), 256))], 6)])], 512))]);
  }), 256))])])])]);
}